import { onInitService } from "./init-service";

// High level API
// NOTE: there is really no need as they are first-level api,
//       but this might be considered Open-Closed complient because
//       we reserve the right to wrap the original APIs and extend them.
export {
  Translation,
  useTranslation,
  withTranslation,
  Trans
} from "react-i18next";

export { registryParse } from "./registry-parse";
export { registryRequest } from "./registry-request";

export const serviceI18N = ({ registerTargets }) => {
  registerTargets({
    ONE_I18N_OVERRIDE_CONFIG: "one/i18n/override/config",
    ONE_I18N_OVERRIDE_MIDDLEWARES: "one/i18n/override/middlewares"
  });

  return [
    {
      target: "$INIT_SERVICE",
      handler: onInitService
    }
  ];
};
